import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { updateExamInGroupOperation } from './operations/update-exam-in-group-operation';
import { PaymentServiceSelector } from '../../../components/payment-service-selector';
import { ExternalExamGroup } from '../../../../../../../api/types/external-exams/external-exam-group';
import { ExternalExamGroupCrud } from '../../../../../../../api/types/external-exams/external-exam-group-crud';
import { EditNumber } from '../../../../../../../component/ui/edit-text/edit-number';
import CancelButton from '../../../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../../../component/ui/buttons/approve-button/approve-buttons';
import externalExamGroupsStore from '../../../../../../../stores/external-exam-groups-store';

interface EditExamInGroupDialogProps {
  group: ExternalExamGroup;
  exam: ExternalExamGroupCrud;
  visible: boolean;
  onHide: () => void;
  onGroupUpdate?: (updatedGroup: ExternalExamGroup) => void;
}

export const EditExamInGroupDialog: React.FC<EditExamInGroupDialogProps> = ({
  group,
  exam,
  visible,
  onHide,
  onGroupUpdate,
}) => {
  const [startAt, setStartAt] = useState<Date>(new Date(exam.startAt));
  const [durationMinutes, setDurationMinutes] = useState<number>(
    exam.durationMinutes,
  );
  const [studentRegistrationDueDate, setStudentRegistrationDueDate] =
    useState<Date>(new Date(exam.studentRegistrationDueDate));
  const [paymentServiceId, setPaymentServiceId] = useState<number | null>(
    exam.paymentServiceId,
  );
  const [paymentServiceVersionId, setPaymentServiceVersionId] = useState<
    number | null
  >(null); // TODO: Add paymentServiceVersionId to ExternalExamGroupExam if API returns it
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setStartAt(new Date(exam.startAt));
    setDurationMinutes(exam.durationMinutes);
    setStudentRegistrationDueDate(new Date(exam.studentRegistrationDueDate));
    setPaymentServiceId(exam.paymentServiceId);
  }, [exam]);

  const handleSave = async () => {
    await updateExamInGroupOperation(
      group.id,
      exam.id,
      {
        startAt,
        durationMinutes,
        studentRegistrationDueDate,
        paymentServiceId: exam.paymentServiceId,
      },
      setLoading,
      () => {
        onHide();
        // Update the parent component's selectedGroup with the updated group from store
        if (onGroupUpdate) {
          const updatedGroup = externalExamGroupsStore.groups.find(
            (g) => g.id === group.id,
          );
          if (updatedGroup) {
            onGroupUpdate(updatedGroup);
          }
        }
      },
    );
  };

  const isValid =
    startAt &&
    durationMinutes > 0 &&
    studentRegistrationDueDate &&
    paymentServiceId &&
    paymentServiceVersionId;

  return (
    <Dialog
      header={`עריכת מבחן: ${exam.abstractExternalExam.examName}`}
      visible={visible}
      onHide={onHide}
      style={{
        width: '600px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      modal
      closable={!loading}
    >
      <div style={{ direction: 'rtl', padding: '8px' }}>
        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            תאריך ושעת התחלה
          </label>
          <Calendar
            value={startAt}
            onChange={(e) => setStartAt(e.value as Date)}
            showTime
            hourFormat="24"
            dateFormat="dd/mm/yy"
            style={{ width: '100%' }}
            inputStyle={{ direction: 'rtl', textAlign: 'right' }}
            panelStyle={{ direction: 'ltr' }}
          />
        </div>

        <EditNumber
          title="משך הבחינה (דקות)"
          value={durationMinutes}
          onChange={setDurationMinutes}
          min={1}
        />

        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            תאריך אחרון לרישום
          </label>
          <Calendar
            value={studentRegistrationDueDate}
            onChange={(e) => setStudentRegistrationDueDate(e.value as Date)}
            dateFormat="dd/mm/yy"
            style={{ width: '100%' }}
            inputStyle={{ direction: 'rtl', textAlign: 'right' }}
            panelStyle={{ direction: 'ltr' }}
          />
        </div>

        {/*        <PaymentServiceSelector
          selectedPaymentServiceId={paymentServiceId}
          onPaymentServiceChange={(id, versionId) => {
            setPaymentServiceId(id);
            setPaymentServiceVersionId(versionId);
          }}
        />*/}

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '20px',
          }}
        >
          <CancelButton onClick={onHide} disabled={loading} />
          <ApproveButtons
            onClick={handleSave}
            isLoading={loading}
            disabled={!isValid}
          />
        </div>
      </div>
    </Dialog>
  );
};
